import { useContext } from "react";

import { ActiveEditorViewContext } from "pages/DevelopWorkspace/contexts/ActiveEditorViewContext/ActiveEditorViewContext";

const useActiveEditorView = () => {
  const {
    activeEditorView,
    setActiveEditorView,
    insertTextAtCursorPosition,
    insertTextAtBottom,
    formatText,
  } = useContext(ActiveEditorViewContext);
  return {
    activeEditorView,
    setActiveEditorView,
    insertTextAtCursorPosition,
    insertTextAtBottom,
    formatText,
  };
};

export default useActiveEditorView;
